import { useBodyClass } from '@/hooks/useBodyClass';
import { SiteFooter } from './SiteFooter';
import { SiteHeader } from './SiteHeader';
import { SkipLink } from './SkipLink';

/**
 * 모든 페이지의 겉껍데기.
 *
 * @param {object} props
 * @param {string} props.bodyClass mobile.css·tablet.css 오버라이드가 쓰는 스코프 클래스
 */
export function PageLayout({ bodyClass, children }) {
  useBodyClass(bodyClass);

  return (
    <>
      <SkipLink />
      <SiteHeader />
      <main id="main">{children}</main>
      <SiteFooter />
    </>
  );
}
